import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import AddIcon from "@material-ui/icons/Add";
import Link from "@material-ui/core/Link";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { adjective as proAdjective } from "@language/provider";
import ContentBadgeDialog from "./ContentBadgeDialog";

// User feedback
//import IconButton from "@material-ui/core/IconButton";
//import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAlt";
//import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";

const { BRAND_NAME } = process.env;

const ContentSources = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	const [checked, setChecked] = React.useState(false);

	const handleChange = () => {
		setChecked((prev) => !prev);
	};

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			{store.sources?.length > 0 && (
				<>
					<Box
						display={"flex"}
						alignItems="center"
						justifyContent={"space-between"}
						position="relative"
					>
						<Button
							color={"primary"}
							onClick={handleChange}
							startIcon={<AddIcon />}
						>
							{store.sources.length} sources
						</Button>
						{/* <Box
							display={"flex"}
							alignItems="center"
							justifyContent={"flex-end"}
							color="grey.600"
						>
							<Box fontSize={12} mr={2}>
								FEEDBACK:
							</Box>
							<IconButton color="inherit" size="small">
								<SentimentSatisfiedAltIcon />
							</IconButton>
							<IconButton color="inherit" size="small">
								<SentimentVeryDissatisfiedIcon />
							</IconButton>
						</Box> */}
					</Box>
					<Collapse in={checked}>
						<Box position="relative" mt={6}>
							<p className={classes.asideSubText}>
								{`${BRAND_NAME} works directly with thousands of expert ${proAdjective.plural} to gather proprietary data and research. We interview experts, conduct questionaires, review their profile and prices they charge customers on ${BRAND_NAME}, and more.`}
							</p>

							<p className={classes.asideSubText}>
								{`Our editors thoroughly fact-check this content with primary sources to ensure accuracy. These include white papers, government data, original reporting, and interviews with industry experts outside our platform. We also reference original research from other reputable publishers where appropriate.`}
							</p>
							<p className={classes.asideSubText}>
								{`You can learn more about the standards we follow in producing accurate, unbiased content in our `}
								<Link
									underline="always"
									onClick={handleClickOpen}
									color="inherit"
								>
									editorial policy
								</Link>
								.
							</p>

							<ol className={classes.sources}>
								{documentToReactComponents(store.sources)}
								{/* {store.sources.map((source, i) => (
									<li key={`source_${i}`}>
										<cite>
											{source.title}
											<br />
											<a
												href={source.link}
												target="_blank"
												rel="noopener noreferrer"
											>
												{source.link}
											</a>
										</cite>
									</li>
								))} */}
							</ol>
						</Box>
					</Collapse>

					{open && (
						<ContentBadgeDialog close={handleClose} open={handleClickOpen} />
					)}
				</>
			)}
		</>
	);
};

ContentSources.propTypes = {};
export default ContentSources;
